import { render, staticRenderFns } from "./ICJMOPIS.vue?vue&type=template&id=63a35e6a&scoped=true"
import script from "./ICJMOPIS.vue?vue&type=script&lang=js"
export * from "./ICJMOPIS.vue?vue&type=script&lang=js"
import style0 from "./ICJMOPIS.vue?vue&type=style&index=0&id=63a35e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a35e6a",
  null
  
)

export default component.exports